export enum EntityStatus {
    add = 1,
    edit = 2
}